import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { globalConfigActions } from "store";


// Images & Icons
import Logo from "assets/images/arrow-logo.svg";
import LogoLight from 'assets/images/arrow-logo-light.svg';
import SettingIcon from "assets/icons/setting.svg";
import NotificationIcon from "assets/icons/notification.svg";
import DummyUserImage from "assets/images/demo-user.png";
import AngleDownBlue from "assets/icons/angle-down-blue.svg";
import LightToggler from 'assets/icons/sun.svg';
import LightTogglerActive from 'assets/icons/sun-active.svg';
import DarkToggler from 'assets/icons/moon.svg';
import DarkTogglerActive from 'assets/icons/moon-active.svg';

function Header() {
  const location = useLocation();
  const dispatch = useDispatch();
  const selectedTheme = useSelector((state)=> state.globalConfig.theme);


  function setTheme( _theme ) {
    dispatch(globalConfigActions.setTheme(_theme));

    if( selectedTheme === 'dark'){
        document.getElementsByTagName("body")[0].classList.add("dark");
        document.getElementsByTagName("body")[0].classList.remove("light");
    }
  
    if(selectedTheme === 'light'){
      document.getElementsByTagName("body")[0].classList.add("light");
      document.getElementsByTagName("body")[0].classList.remove("dark");
    }
  }

  function getPageTitle() {
    let pageTitle = "Not Found";
    if (
      location.pathname === "/" ||
      location.pathname === "/capital-projects-dashboard"
    ) {
      pageTitle = "Capital Projects Dashboard";
    }
    if (location.pathname === "/project-kpis") {
      pageTitle = "Project KPIs Dashboard";
    }
    if (location.pathname === "/troubled-projects-dashboard") {
      pageTitle = "Troubled Projects Dashboard";
    }
    if (location.pathname === "/delayed-projects-dashboard") {
      pageTitle = "Delayed Projects Dashboard";
    }
    if (location.pathname === "/projects-performance-dashboard") {
      pageTitle = "Projects Performance Dashboard";
    }
    if (location.pathname === "/time-overrun-projects") {
      pageTitle = "Time Overrun Projects Dashboard";
    }
    if (location.pathname === "/change-order") {
      pageTitle = "Change Order";
    }
    if (location.pathname === "/contractor-analysis") {
      pageTitle = "Contractor Analysis";
    }
    if (location.pathname === "/withdrawn-projects-dashboard") {
      pageTitle = "Withdrawn Projects Dashboard";
    }
    if (location.pathname === "/suspended-projects-dashboard") {
      pageTitle = "Suspended Projects Dashboard";
    }
    return pageTitle;
  }
  return (
    <header>
      <div className="left">
      {
                selectedTheme === 'dark'?  <img src={Logo} alt='#'/>:<img src={LogoLight} alt='#'/>
            }
      </div>
      <div className="middle">
        <h3>{getPageTitle()}</h3>
      </div>
      <div className="right">
        <div className="icon-set">
          <div className="toggler">
            

            {selectedTheme === "dark" ? (
                <>
                    <img src={DarkTogglerActive} alt="#" onClick={()=> { setTheme('dark') }}/>
                    <img src={LightToggler} alt="#" onClick={()=> { setTheme('light') }}/>
                </>
                
              ) : (
                <>
                <img src={DarkToggler} alt="#" onClick={()=> { setTheme('dark') }}/>
                <img src={LightTogglerActive} alt="#" onClick={()=> { setTheme('light') }}/>
                </>
              )}

          </div>
          <img src={SettingIcon} alt="#" className="gap-less" />
          <div className="wrapper gap-more">
            <div className="notification-count">10</div>
            <img src={NotificationIcon} alt="#" />
          </div>
        </div>
        <div className="account-settings">
          <div className="aligned">
            <img src={DummyUserImage} alt="#" />
            <div className="user-info">
              <span>Mohammad Reda</span>
              <span>Super Admin</span>
            </div>
            <img src={AngleDownBlue} alt="#" className="angle-down-blue" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
